import Spacer from '@/common/components/spacer';
import { Input, InputProps } from '@/shadcn-ui/input';
import { Label } from '@/shadcn-ui/label';
import { cn } from '@/shadcn-ui/utils';
import React from 'react';

export interface InputWithIconProps extends InputProps {
  label?: string;
  containerClassName?: string;
  icon: React.ReactNode;
  iconContainerClassName?: string;
  position: 'left' | 'right';
  onClickDelegate: () => void;
}

const InputWithIcon = React.forwardRef<HTMLInputElement, InputWithIconProps>(
  (
    {
      position,
      variant = 'light',
      label,
      containerClassName,
      icon,
      iconContainerClassName,
      onClickDelegate,
      className,
      ...props
    }: InputWithIconProps,
    ref
  ) => {
    const inputId = label?.replaceAll(/ /g, '');
    return (
      <>
        {label !== undefined && (
          <>
            <Label htmlFor={inputId} variant={variant}>
              {label}
            </Label>
            <Spacer variant="height4" />
          </>
        )}

        <div className={cn('relative flex flex-col', containerClassName)}>
          {position === 'left' && (
            <div
              role="button"
              tabIndex={0}
              onClick={onClickDelegate}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onClickDelegate();
                }
              }}
              className={cn('absolute left-[16px] top-[14px]', iconContainerClassName)}
            >
              {icon}
            </div>
          )}

          <Input
            id={inputId}
            ref={ref}
            className={cn(className, position === 'left' ? 'pl-12' : 'pr-12')}
            {...(props as InputProps)}
          />

          {position === 'right' && (
            <div
              role="button"
              tabIndex={0}
              onClick={onClickDelegate}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onClickDelegate();
                }
              }}
              className={cn('absolute right-[16px] top-[14px]', iconContainerClassName)}
            >
              {icon}
            </div>
          )}
        </div>
      </>
    );
  }
);

InputWithIcon.displayName = 'InputWithIcon';
export { InputWithIcon };
